module.exports = __webpack_public_path__ + "img/pocket-13_en.2cf25ae.jpg";